<script lang="ts">
import { defineComponent, reactive } from 'vue'
import CompanyProfile from '@/components/solutions/CompanyProfile.vue'
import stateInitializer from '@/models/stateInitializer'

export default defineComponent({
  name: 'SolutionAsideSecondary',

  components: {
    CompanyProfile,
  },

  setup() {
    interface State {
      solution: Solution,
    }

    const state: State = reactive({
      solution: {
        id: undefined,
        title: '',
        company: {
          name: '',
          postalCode: '',
          address1: '',
          address2: '',
          capital: '',
          numberOfEmployees: '',
        },
      },
    })

    stateInitializer(state, 'asideSecondary')

    return {
      // data
      state,
    }
  },
})
</script>

<template>
  <CompanyProfile
    v-if="state.solution.company"
    :solution-title="state.solution.title"
    :summary="state.solution.company" />
</template>
